import { RefObject } from "react";

import Loading from "@components/loading/loading";

const TopicSidebarLoading = ({
  focusRef,
  onClose,
}: {
  focusRef: RefObject<HTMLButtonElement>;
  onClose: () => void;
}) => {
  return (
    <div className="-mt-3" aria-label="Loading sidebar topic">
      <div className="pt-16">
        <Loading>Loading the topic...</Loading>
      </div>
    </div>
  );
};

export default TopicSidebarLoading;
